import { mapValues } from 'lodash';
/**
 * Version 17 migrations registration summary widget - hotel request
 * - Adding default configurations for hotel request
 */
export default function v17(website) {
  return {
    ...website,
    eventVersion: 17,
    layoutItems: mapValues(website.layoutItems, layoutItem => {
      if (layoutItem.widgetType === 'RegistrationSummary' && !layoutItem.config.hotelRequestInformation) {
        return {
          ...layoutItem,
          config: {
            ...layoutItem.config,
            hotelRequestInformation: {
              display: true,
              header: 'EventWidgets_RegistrationSummary_DefaultHotelHeader__resx'
            }
          }
        };
      }
      return layoutItem;
    })
  };
}
